// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { OperatorConfiguration } from '@daml.js/utility-collateral-app-v1/lib/Utility/Collateral/App/Model/Configuration/Operator';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useOperatorConfiguration: () => UseQueryResult<
  TemplateContract<OperatorConfiguration> | null,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  // COLLATERAL: fix
  const { operator } = useParties();
  const offset = useLedgerEnd();
  return useQuery({
    queryKey: ['queryCollateralOperatorConfiguration', ledgerApi, operator, offset],
    queryFn: async () => {
      return ledgerApi.queryCollateralOperatorConfiguration(offset!, operator);
    },
    refetchInterval: false,
  });
};

export default useOperatorConfiguration;
